"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _select = _interopRequireDefault(require("../select"));
var _input = _interopRequireDefault(require("../input"));
var _InputElement = _interopRequireDefault(require("./InputElement"));
var _select2 = require("../rc-components/select");
var _enum = require("../_util/enum");
var _enum2 = require("../select/enum");
var _ConfigContext = _interopRequireDefault(require("../config-provider/ConfigContext"));
function isSelectOptionOrSelectOptGroup(child) {
  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
var AutoComplete = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AutoComplete, _Component);
  var _super = (0, _createSuper2["default"])(AutoComplete);
  function AutoComplete() {
    var _this;
    (0, _classCallCheck2["default"])(this, AutoComplete);
    _this = _super.apply(this, arguments);
    _this.getInputElement = function () {
      var _this$props = _this.props,
        children = _this$props.children,
        inputProps = _this$props.inputProps;
      var element = children && /*#__PURE__*/(0, _react.isValidElement)(children) && children.type !== _select2.Option ? /*#__PURE__*/(0, _react.cloneElement)(_react.Children.only(children), {
        labelLayout: 'none'
      }) : /*#__PURE__*/_react["default"].createElement(_input["default"], (0, _extends2["default"])({}, inputProps, {
        border: false
      }));
      var elementProps = (0, _objectSpread2["default"])({}, element.props);
      delete elementProps.children;
      return /*#__PURE__*/_react["default"].createElement(_InputElement["default"], (0, _extends2["default"])({}, elementProps), element);
    };
    _this.saveSelect = function (node) {
      _this.select = node;
    };
    return _this;
  }
  (0, _createClass2["default"])(AutoComplete, [{
    key: "focus",
    value: function focus() {
      this.select.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.select.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;
      var _this$props2 = this.props,
        size = _this$props2.size,
        _this$props2$classNam = _this$props2.className,
        className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
        notFoundContent = _this$props2.notFoundContent,
        customizePrefixCls = _this$props2.prefixCls,
        optionLabelProp = _this$props2.optionLabelProp,
        dataSource = _this$props2.dataSource,
        children = _this$props2.children;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('select', customizePrefixCls);
      var cls = (0, _classnames["default"])((_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-lg"), size === _enum.Size.large), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-sm"), size === _enum.Size.small), (0, _defineProperty2["default"])(_classNames, className, !!className), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-show-search"), true), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-auto-complete"), true), _classNames));
      var options;
      var childArray = _react.Children.toArray(children);
      if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
        options = children;
      } else {
        options = dataSource ? dataSource.map(function (item) {
          if ( /*#__PURE__*/(0, _react.isValidElement)(item)) {
            return item;
          }
          switch ((0, _typeof2["default"])(item)) {
            case 'string':
              return /*#__PURE__*/_react["default"].createElement(_select2.Option, {
                key: item
              }, item);
            case 'object':
              return /*#__PURE__*/_react["default"].createElement(_select2.Option, {
                key: item.value
              }, item.text);
            default:
              throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
          }
        }) : [];
      }
      return /*#__PURE__*/_react["default"].createElement(_select["default"], (0, _extends2["default"])({}, this.props, {
        prefixCls: prefixCls,
        className: cls,
        mode: _enum2.SelectMode.combobox,
        optionLabelProp: optionLabelProp,
        getInputElement: this.getInputElement,
        notFoundContent: notFoundContent,
        ref: this.saveSelect
      }), options);
    }
  }], [{
    key: "contextType",
    get: function get() {
      return _ConfigContext["default"];
    }
  }]);
  return AutoComplete;
}(_react.Component);
exports["default"] = AutoComplete;
AutoComplete.displayName = 'AutoComplete';
AutoComplete.Option = _select2.Option;
AutoComplete.OptGroup = _select2.OptGroup;
AutoComplete.defaultProps = {
  transitionName: 'slide-up',
  optionLabelProp: 'children',
  choiceTransitionName: 'zoom',
  showSearch: false,
  filterOption: false
};